import React, { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import Modal from "../utils/Modal";

import { ReactComponent as Shadow } from "../assets/sensei/levitating-shadow.svg";
import { ReactComponent as RubyGem } from "../assets/gems/ruby.svg";
import { ReactComponent as CitrineGem } from "../assets/gems/citrine.svg";
import { ReactComponent as TopazGem } from "../assets/gems/topaz.svg";
import { ReactComponent as EmeraldGem } from "../assets/gems/emerald.svg";
import { ReactComponent as AquamarineGem } from "../assets/gems/aquamarine.svg";
import { ReactComponent as TanzaniteGem } from "../assets/gems/tanzanite.svg";
import { ReactComponent as AmethystGem } from "../assets/gems/amethyst.svg";
import { ReactComponent as DownArrow } from "../assets/icons/arrows/down.svg";
import { useOnScreen } from "../hooks";
import LevitatingSensei from "../components/LevitatingSensei";
import { requestInvite } from "../utils/helpers";
import GPhone from "../components/animated/GPhone";
import Button from "../components/Button";
import VideoSection from "../components/VideoSection";

function HeroHome({ phoneRef }) {
  const [deckModalOpen, setDeckModalOpen] = useState(false);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [isVideoStarted, setIsVideoStarted] = useState(false);

  const history = useHistory();
  const isPhoneVisible = useOnScreen(phoneRef);
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  return (
    <section>
      <div
        className="absolute left-0 bottom-0 -ml-20 hidden lg:block pointer-events-none"
        aria-hidden="true"
        data-aos="fade-up"
        data-aos-delay="400"
      ></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
        {/* Illustration behind hero content */}

        {/* Hero content */}
        <div className="relative pt-32 pb-10 md:pt-40 md:pb-16">
          {/* Section header */}
          <div className="mx-auto text-center pb-12 md:pb-16">
            {/* Desktop and Tablet */}
            <div className="hidden md:flex justify-center items-center w-full">
              <div className="flex flex-col w-3/5 ml-12">
                <div
                  className="text-6xl h4 mb-3 text-white text-left font-bold"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  Stop Limiting Your Generosity...
                </div>
                <div
                  className="text-left mt-3 md:text-3xl text-xl text-white"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <p>
                    Your heart says give more. Your wallet says you can't. We're
                    changing that.
                  </p>
                </div>

                {/* <div
                  className="flex justify-start mt-12"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <Button
                    text="Submit"
                    className={`w-1/2`}
                    variant="primary"
                    textSize="text-2xl"
                    onClick={() => requestInvite()}
                  >
                    Join Generos
                  </Button>
                </div> */}
              </div>
              <div className="w-1/2">
                <VideoSection
                  className="flex flex-col justify-center"
                  setIsVideoStarted={setIsVideoStarted}
                  setVideoModalOpen={setVideoModalOpen}
                />
              </div>
            </div>
            {/* Mobile */}
            <div className="md:hidden">
              <div className="flex flex-col justify-center items-center">
                <div
                  className="flex flex-col text-xxl h1 md:leading-normal mb-6 text-white text-center"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <p>Stop Limiting Your Generosity...</p>
                </div>
                <div
                  className="text-3xl text-white text-center mb-6"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <p>Your heart says give more.</p>
                  <p>Your wallet says you can't.</p>
                  <p>We're changing that.</p>
                </div>
                <div className="w-full">
                  <VideoSection
                    className="flex flex-col justify-center mt-6"
                    setIsVideoStarted={setIsVideoStarted}
                    setVideoModalOpen={setVideoModalOpen}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Modal */}
          <Modal
            id="video-modal"
            ariaLabel="video-modal-headline"
            show={videoModalOpen}
            handleClose={() => {
              setIsVideoStarted(false);
              setVideoModalOpen(false);
            }}
          >
            <div className="relative pb-9/16">
              <iframe
                className="absolute w-full h-full"
                src={"https://www.youtube.com/embed/mQokBDiEgOI"}
                title="Video"
                allowFullScreen
              ></iframe>
            </div>
          </Modal>

          {/* Hero image */}
          <div
            className={`absolute bottom-0 md:flex justify-center w-full hidden mt-24 ${
              isPhoneVisible ? "opacity-0" : ""
            }`}
          >
            <DownArrow className="animate-bounce w-16 fill-current text-primary-1" />
          </div>

          <Modal
            id="modal"
            ariaLabel="modal-headline"
            show={deckModalOpen}
            handleClose={() => setDeckModalOpen(false)}
          >
            <div className="reFlative pb-9/16">
              <iframe
                src="https://slides.com/patricklewis/generos-io/embed?token=FCRoUuML&style=hidden"
                className="absolute w-full h-full"
                title="Generos (IO)"
                scrolling="no"
                frameBorder="0"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                allowFullScreen
              ></iframe>
            </div>
          </Modal>
        </div>
      </div>
    </section>
  );
}

export default HeroHome;
